export const NAMESPACE = 'PLATFORM'
export const TPA_LOADING_ERROR_HEADER_KEY = 'PLATFORM_Viewer_App_Didn’t_Load_Header'
export const TPA_LOADING_ERROR_HEADER_DEFAULT = 'Widget Didn’t Load'
export const TPA_LOADING_ERROR_TEXT1_KEY = 'PLATFORM_Viewer_App_Didn’t_Load_Sub_Text1'
export const TPA_LOADING_ERROR_TEXT1_DEFAULT = 'Check your internet and refresh this page.'
export const TPA_LOADING_ERROR_TEXT2_KEY = 'PLATFORM_Viewer_App_Didn’t_Load_Sub_Text2'
export const TPA_LOADING_ERROR_TEXT2_DEFAULT = 'If that doesn’t work, contact us.'
export const TPA_LOADING_ERROR_RELOAD_KEY = 'PLATFORM_Viewer_App_Didn’t_Load_Sub_Text3'
export const TPA_LOADING_ERROR_RELOAD_DEFAULT = 'Refresh this page'
